module.exports = __webpack_public_path__ + "img/03_Button-6.a47ad81c.png";